import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.fund.investment');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-fund-investment',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.widget.fund.investment/view.scss */
:host {
  display: block;
  height: 100%;
}

.wiz-form {
  border: 1px solid #6C8DF6;
}

.form-control-flush {
  text-align: left !important;
}`],
})
export class PortalLpsysadminWidgetFundInvestmentComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() fund: any;
    @Input() investments: any;
    @Input() event: any;

    public async ngOnInit() {
        await this.service.init();
        for (let i = 0; i < this.investments.length; i++) {
            this.investments[i].investment_date = moment(this.investments[i].investment_date).format("YYYY-MM-DD");
            this.initSells(this.investments[i]);
        }

        await this.service.render();
    }

    private initSells(investment: any) {
        if (investment.extra?.sells && investment.extra.sells.length > 0) {
            investment.sells = investment.extra.sells;
        } else {
            investment.sells = [];
            for (let i = 1; i <= 5; i++) {
                const data = investment[`sell${i}_data`] || {};
                const amount = investment[`sell${i}_amount`];
                if (data.date || data.count || data.per_share || amount || data.target) {
                    investment.sells.push({
                        date: data.date || '',
                        count: data.count || '',
                        per_share: data.per_share || '',
                        amount: amount || '',
                        target: data.target || ''
                    });
                }
            }
        }
    }

    public async addSell(investment: any) {
        if (!investment.sells) investment.sells = [];
        investment.sells.push({});
        await this.service.render();
    }

    public async removeSell(investment: any, idx: number) {
        investment.sells.splice(idx, 1);
        await this.service.render();
    }

    private prepareSaveData(company: any): any {
        let data = JSON.parse(JSON.stringify(company));
        const sells = data.sells || [];

        if (!data.extra) data.extra = {};
        data.extra.sells = sells;

        for (let i = 1; i <= 5; i++) {
            const sell = sells[i - 1];
            if (sell && (sell.date || sell.count || sell.per_share || sell.amount || sell.target)) {
                data[`sell${i}_amount`] = sell.amount || null;
                data[`sell${i}_data`] = {
                    date: sell.date || null,
                    count: sell.count || null,
                    per_share: sell.per_share || null,
                    target: sell.target || null
                };
            } else {
                data[`sell${i}_amount`] = null;
                data[`sell${i}_data`] = {};
            }
        }

        delete data.sells;
        delete data.ocrLoading;
        return data;
    }

    public async update(company) {
        let data = this.prepareSaveData(company);
        data.fund_id = this.fund.id;
        const { code, data: resData } = await wiz.call("update", { info: JSON.stringify(data) });

        if (code == 200) {
            resData.investment_date = moment(resData.investment_date).format("YYYY-MM-DD");
            let idx = this.investments.indexOf(company);
            this.investments[idx] = resData;
            this.initSells(this.investments[idx]);
            await this.alert(`저장되었습니다.`, '확인', false, 'success');
        } else {
            await this.alert(`오류가 발생했습니다. 다시 저장해주세요.`);
        }

        this.service.render();
    }

    public async clearValue(obj, key) {
        obj[key] = null;
        await this.service.render();
    }

    public async upload(item, target) {
        let files = await this.service.file.select();
        if (files.length == 0) return;

        await this.service.loading.show();
        let fd = new FormData();
        fd.append('upload', files[0]);
        let fdurl = '/file/upload';
        const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
        item[target] = url;

        await this.service.loading.hide();
        this.service.render();
    }

    public async add() {
        this.investments.push({ company: {}, extra: {}, sells: [] });
        this.service.render();
    }

    public async addFile(company) {
        if (!company.extra.attachment) company.extra.attachment = [];
        company.extra.attachment.push({});
        this.service.render();
    }

    public async remove(item) {
        if (item.id) {
            let res = await this.alert(`투자기업 '${item.company_name}'을 정말로 삭제하시겠습니까?`, '삭제', '취소');
            if (!res) return;

            const { code } = await wiz.call("remove", { info: JSON.stringify(item) });

            if (code != 200) {
                await this.alert(`오류가 발생했습니다.`);
                return
            }
        }

        this.investments.remove(item);
        this.service.render();
    }

    public async alert(message: string, action: string = '확인', cancel: any = false, status: string = 'error') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public findDemodayModal: any;
    public findDemodayEvent: any = {
        close: async () => {
            this.findDemodayModal = null;
            await this.service.render();
        },
        select: async (item) => {
            let selected: any = this.findDemodayModal.item;
            selected.registed_number = item.registed_number;
            this.investments[this.findDemodayModal.index].company = { ...this.investments[this.findDemodayModal.index].company, ...item };
            this.findDemodayModal = null;
            await this.service.render();
        }
    }

    public async unlinkDemoday(item) {
        item.registed_number = null;
        await this.service.render();
    }

    public async findDemoday(item, i) {
        this.findDemodayModal = { text: item.registed_number, item: item, index: i };
        await this.service.render();
    }

    public async loadInfo(item) {
        const { code, data } = await wiz.call("loadinfo", { info: JSON.stringify(item) });

        item.company_name = data.company_name;
        item.extra.ceo = data.ceo ? data.ceo : "";
        item.extra.founded = data.extra ? data.extra.founded ? data.extra.founded : "" : "";
        item.extra.location = data.extra ? data.extra.location_short ? data.extra.location_short : "" : "";

        if (code != 200) {
            await this.alert(`오류가 발생했습니다.`);
            return
        }

        this.service.render();
    }

    public async calcAmount(e, i) {
        if (this.investments[i].price_per_share && this.investments[i].invested_shares) {
            this.investments[i].investment_amount = this.investments[i].price_per_share * this.investments[i].invested_shares
        }

        await this.service.render();
    }

    public async uploadBusinessCert(investment) {
        let files = await this.service.file.select({ accept: 'image/*,.pdf' });
        if (!files || files.length == 0) return;

        investment.ocrLoading = true;
        await this.service.render();

        let fd = new FormData();
        fd.append('file', files[0]);

        try {
            let { code, data } = await wiz.call("ocr_business_registration", fd, {
                processData: false,
                contentType: false
            });

            if (code == 200 && data.result) {
                let r = data.result;
                let extracted = false;
                if (r.company_name) { investment.company_name = r.company_name; extracted = true; }
                if (r.ceo) {
                    if (!investment.extra) investment.extra = {};
                    investment.extra.ceo = r.ceo;
                    extracted = true;
                }
                if (r.location) {
                    if (!investment.extra) investment.extra = {};
                    investment.extra.location = r.location;
                    extracted = true;
                }
                if (r.registed_number) {
                    investment.registed_number = r.registed_number;
                    extracted = true;
                }
                if (extracted) {
                    let fields = [];
                    if (r.registed_number) fields.push("사업자등록번호");
                    if (r.company_name) fields.push("기업명");
                    if (r.ceo) fields.push("대표자");
                    if (r.location) fields.push("소재지");
                    await this.alert(`추출 완료: ${fields.join(', ')}`, '확인', false, 'success');
                } else {
                    console.log("OCR raw text:", data.raw_text);
                    await this.alert("사업자등록증에서 정보를 추출하지 못했습니다.\n이미지가 선명한지 확인해주세요.");
                }
            } else {
                let msg = (data && data.message) ? data.message : "OCR 처리에 실패했습니다.";
                if (data && data.raw_text) console.log("OCR raw text:", data.raw_text);
                await this.alert(msg);
            }
        } catch (e) {
            console.error("OCR error:", e);
            await this.alert("OCR 처리 중 오류가 발생했습니다.");
        }

        investment.ocrLoading = false;
        await this.service.render();
    }
}

export default PortalLpsysadminWidgetFundInvestmentComponent;